import { Injectable } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { UploaderApiService } from '../api/uploader-api.service';
import { ToastrMessages } from '../constants/ToastrMessages';
import StorageHelper from '../helpers/Storage.helper';
import { UploadPromiseResponse } from '../models/Upload';

@Injectable({
  providedIn: 'root',
})
export class UserImportService {
  private readonly uploader: FileUploader;
  public readonly maxFileSize = 2 * 1024 * 1024 * 1024; // 2GB

  public uploaderObservable = new Subject<any>();

  // prettier-ignore
  constructor(
    private toastrService: ToastrService,
    private uploaderApiService: UploaderApiService
  ) {
    this.uploader = this.setAssetUploaderInstance();
    this.setUploaderMethods();
  }

  get uploaderInstance(): FileUploader {
    return this.uploader;
  }

  setAssetUploaderInstance(): FileUploader {
    return new FileUploader({
      url: this.uploaderApiService.getImportUsersUrl(),
      authToken: `Bearer ${StorageHelper.getToken()}`,
      autoUpload: false,
      itemAlias: 'file',
      removeAfterUpload: false,
      maxFileSize: this.maxFileSize,
    });
  }

  setUploaderMethods(): void {
    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => this.emitResponse(fileItem, progress.toString(), true);
    this.uploader.onSuccessItem = (fileItem: FileItem, response: any) => this.emitResponse(fileItem, response, false);
    this.uploader.onErrorItem = (fileItem: FileItem, response: any) => this.handleError(fileItem, response);
    this.uploader.onBuildItemForm = (fileItem: FileItem, form) => this.computeBuildItem(fileItem, form);
    this.uploader.onWhenAddingFileFailed = (_, filter, __) => this.addingFileFailed(filter);
  }

  uploadFile(): void {
    this.computeFileNames();
    this.uploader.uploadAll();
  }

  private computeFileNames(): void {
    this.uploader.queue.forEach(
      (file: FileItem) => (file.file.name = new Date().getTime() + '_' + file.file.name.replace(/[^0-9a-zA-z._&\-\s]+/g, ''))
    );
  }

  private emitResponse(fileItem: FileItem, response: string, progress: boolean): void {
    const result: UploadPromiseResponse = new UploadPromiseResponse(fileItem, response);
    this.uploaderObservable.next({ result, progress });
    if (!progress) {
      this.uploader.progress = 0;
    }
  }

  private handleError(fileItem: FileItem, response: string): void {
    if (response && JSON.parse(response).error === 'invalid_token') {
      this.toastrService.error(...ToastrMessages.EXPIRED_SESSION);
    } else {
      this.emitResponse(fileItem, response, false);
    }
  }

  private computeBuildItem(fileItem: FileItem, form): any {
    form.append('checkOnly', fileItem.formData.checkOnly);
    return { fileItem, form };
  }

  private addingFileFailed(filter: any): void {
    switch (filter.name) {
      case 'fileSize':
        this.toastrService.error(...ToastrMessages.ERROR_MAX_FILE_SIZE);
        break;
      default:
        break;
    }
  }
}
